// extracted by mini-css-extract-plugin
export default {"container":"tz7e","black":"HVbH","blue":"EkUt"};